import DHighlightText from '@d-components/d-highlight-text/d-highlight-text.vue';

export default {
  components: {
    DHighlightText,
  },
  props: {
    result: {
      type: Object,
      required: true,
    },
    resultUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    searchTerm() {
      return this.$store.getters['Search/get-search-term'];
    },
  },
};
